export const m2oConvert = (
  metricArguments: Map<string, any>
): Record<string, any> => {
  const newObject: Record<string, any> = {}
  for (const [key, value] of metricArguments) {
    newObject[key] = value
  }
  return newObject
}

export const o2mConvert = (
  metricArguments: Record<string, any>
): Map<string, any> => {
  const newMap: Map<string, any> = new Map()
  Object.entries(metricArguments).forEach((entry) => {
    newMap.set(entry[0], entry[1])
  })
  return newMap
}

export const parseToPrimitive = (value: any) => {
  try {
    return JSON.parse(value)
  } catch {
    return value
  }
}
